<template>
  <div>
    <p style="margin-bottom: .25rem;">{{ $t('pushAsk.text') }}</p>
    <div class="systemNotification__btn-row">
      <up-button
        class="systemNotification__btn btn-decline"
        :disabled="busy"
        @click="$emit('close')"
      >
        {{ $t('pushAsk.later') }}
      </up-button>
      <up-button
        class="systemNotification__btn btn-success"
        :disabled="busy"
        @click="enable"
      >
        {{ $t('pushAsk.enable') }}
      </up-button>
    </div>
    <button
      v-if="showOptout"
      type="button"
      class="pushAsk__optout"
      :disabled="busy"
      @click="never"
    >
      {{ $t('pushAsk.never') }}
    </button>
  </div>
</template>

<script>
import push, { PUSH_ASK_OPTOUT_FROM } from '@/components/mixins/methodsPush';

export default {
  name: 'pushAsk',
  mixins: [push],
  emits: ['close'],
  data() {
    return {
      busy: false,
      // Считаем при появлении: показ уже состоялся, что бы человек дальше
      // ни нажал и даже если просто ушёл с экрана.
      askCount: 0,
    };
  },
  computed: {
    showOptout() {
      return this.askCount >= PUSH_ASK_OPTOUT_FROM;
    },
  },
  created() {
    this.markPushAsked();
    this.askCount = this.pushAskCount();
  },
  methods: {
    // Разрешение запрашивается прямо здесь: это обработчик нажатия, а вне его
    // браузер своё окно не покажет.
    enable() {
      this.busy = true;

      return this.requestPushPermission()
        .then((permission) => (permission === 'granted' ? this.subscribePush() : false))
        .finally(() => {
          this.busy = false;
          this.$emit('close');
        });
    },
    never() {
      this.disablePushAsk();
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.pushAsk__optout {
  display: block;
  margin: 12px auto 0;
  padding: 0;
  font: inherit;
  font-size: 13px;
  color: $color-text-secondary;
  text-decoration: underline;
  background: transparent;
  border: 0;
  cursor: pointer;
}
</style>
